<template>
  <div 
    v-if="active"
    id="change-warning-modal" 
    :class="{'is-active': active}"
    class="ec-modal change-warning-modal"
    @click.self="closeModal" >
    <div 
      class="ec-modal-main is-danger">
      <a 
        href="#" 
        class="close-icon modal-close" 
        @click.prevent.stop="closeModal()"/>
      <div class="ec-modal-headline">{{ $t('modals.warning') }}</div>
      <div class="ec-modal-text">
        {{ $t('modals.delete_all_answers_warning') }}
      </div>
      <div class="ec-modal-btn-wrapper">
        <button 
          id="ec-modal-variable-cancel" 
          class="ec-modal-btn-cancel btn is-grey modal-close" 
          @click.stop="closeModal()">{{ $t('modals.cancel') }}</button>
        <button
          id="ec-modal-variable-ok" 
          class="ec-modal-btn-ok btn is-red" 
          @click="ok()">{{ $t('modals.allow_changes') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
    import Modal from './Modal.mixin.vue'

    export default {
        mixins: [Modal],
        data: function () {
            return {

            }
        },
        created() {
            this.$event.$on('call-change-warning-modal', () => {
              this.active = true
            })
        },
        methods: {
            ok() {
                this.$store.page.changeWarningEnabled = false
                this.$store.page.jumpToEndEnabled = false
                this.$store.readOnly = false
                this.closeModal()
            }
        },
    }
</script>
